import { getConfig } from '@atlassian/atlassian-studio-common';

export const redirectToLogin = (): void => {
	const href = window.location.href;
	const loginUrl = `${getConfig().atlassianAccountUrl}/login?continue=${encodeURIComponent(href)}`;
	window.location.href = loginUrl;
};
